import { User } from "../../../shared/interfaces/user";
import { getAuthHeaders } from "../../../shared/services/authentication";
import { BASE_URL } from "../../../shared/utils/variables";

const baseURL = BASE_URL;

export const fetchUsersOfCompanyService = async (
    companyId: string,
    includeRequester = false
): Promise<User[]> => {
    const query = includeRequester ? '?includeRequester=true' : '';
    const url = `${baseURL}/user/${companyId}/company${query}`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}

export const fetchNotificationRecipientsOfCompanyService = async (companyId: string): Promise<User[]> => {
    return fetchUsersOfCompanyService(companyId, true);
}

export const fetchUsersService = async (): Promise<User[]> => {
    const url = `${baseURL}/users`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}

export const createUserService = async (user: User): Promise<User> => {
    const url = `${baseURL}/user`;

    const options = {
        method: 'POST',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}

export const fetchUserService = async (id: string): Promise<User> => {
    const url = `${baseURL}/user/${id}`;

    const options = {
        method: 'GET',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}

export const updateUserService = async (id: string, user: User): Promise<User> => {
    const url = `${baseURL}/user/${id}`;

    const options = {
        method: 'PUT',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify(user),
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}

export const updatePasswordService = async ({email, password}: {email: string, password: string}): Promise<User> => {
    const url = `${baseURL}/resetPassword`;

    const options = {
        method: 'POST',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
        body: JSON.stringify({email, password}),
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}

export const recoveryEmail = async (email: string): Promise<{success: string, message: string}> => {
    const url = `${baseURL}/forgot-password`;

    const options = {
        method: 'POST',
        headers: { 
            "Content-Type": "application/json",
        },
        body: JSON.stringify({email}),
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}

export const deleteUserService = async (id: string): Promise<User> => {
    const url = `${baseURL}/user/${id}`;

    const options = {
        method: 'DELETE',
        headers: { 
            ...getAuthHeaders(),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Erro HTTP ${response.status}`);
    }

    return await response.json();
}
